import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        pc_url: '',
        mobile_url: '',
        show_type: ''
      },
      dateVal: [],
      picfileList: [],
      picfileList1: [],
      showList: [{
        label: '每次进入首页都显示',
        value: 1
      }, {
        label: '每天显示一次',
        value: 2
      }, {
        label: '只显示一次',
        value: 3
      }],
      dialogShow: false,
      rules: {
        pc_url: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        mobile_url: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        show_type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        start_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (data) {
                  _this.form = _objectSpread({}, data);
                  _this.picfileList = data.pc_url ? [data.pc_url] : [];
                  _this.picfileList1 = data.mobile_url ? [data.mobile_url] : [];
                  _this.dateVal = [data.start_time, data.end_time];
                }

                console.log("this.form", _this.form);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e) {
      this.picfileList = e;
      this.form.pc_url = e[0] && e[0].response ? e[0].response.data : '';
    },
    imgMobileChange: function imgMobileChange(e) {
      this.picfileList1 = e;
      this.form.mobile_url = e[0] && e[0].response ? e[0].response.data : '';
    },
    dateChange: function dateChange(e) {
      this.form.start_time = this.dateVal ? this.dateVal[0] : '';
      this.form.end_time = this.dateVal ? this.dateVal[1] : '';
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = _objectSpread(_objectSpread({}, this.copyform), {}, {
        id: type ? this.form.id : ""
      });
      this.dateVal = [];
      this.picfileList = [];
      this.picfileList1 = [];
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          console.log('this.form.dateVal', _this2.form.dateVal); // if(this.form.dateVal.length){
          // 	data.start_time = this.form.dateVal[0];
          // 	data.end_time = this.form.dateVal[1]
          // }

          var reqFn = data.id ? 'activityImgPopUpUpdate' : 'activityImgPopUpAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};